
import { hydrateCSRTemplate } from "@fiverr-private/layout_lib/CSRTemplate";

import FipMigrationModalManager from '/home/circleci/app/packages/layout-fib-user-migration-component/src/entries/FipMigrationModalManager';

const element = typeof document !== 'undefined' && document.querySelector('#FipMigrationModalManager');
if (element) {
    const props = window.initialData['FipMigrationModalManager'];

    hydrateCSRTemplate(FipMigrationModalManager, props, element, 'FipMigrationModalManager', 'FipMigrationModalManager');
}
export default FipMigrationModalManager;
